module.exports = __webpack_public_path__ + "img/CEFTA.58c611ec.png";